import { useLiveQuery } from 'dexie-react-hooks';
import { DataPointTreeItem } from 'src/pages/SignInPage/_BLL/types';
import { db } from '../init';

export const useGetDataPointTreeBoolean = (): DataPointTreeItem[] | undefined => {
	return useLiveQuery(() => db.dataPointTreeBoolean.toArray());
};
